import Box from "@mui/material/Box";
import { Popover, Autocomplete, TextField, Typography } from "@mui/material";
import AppButton from "../common/AppButton";
import { StyledDialogTitle } from "../common/StyledDialogTitle";
import { initialDropdownValues } from "../../utils/constants";
import { styles } from "./styles";

export const FilterPopover = ({ dropDownOptions, filterValues, setFilterValues, setFilterValuesParent, anchorEl, setAnchorEl }: any) => {
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const handleClosePopover = () => {
        setFilterValues(initialDropdownValues);
        setFilterValuesParent(initialDropdownValues);
        setAnchorEl(null);
    };

    const handleDropdownChange = (key: string) => (event: any, value: any) => {
        setFilterValues((prevValues: any) => ({
            ...prevValues,
            [key]: value,
        }));
    };

    const handleSubmit = () => {
        setFilterValuesParent(filterValues);
        setAnchorEl(null);
    };

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            sx={{
                ...styles.filterPopover,
                zIndex: 1000, // Ensure the popover is on top of other elements (DatePicker inside it)
                overflow: "visible", // Allow the DatePicker calendar to show outside the popover
            }}
            disableEnforceFocus // Avoid focus issues that may prevent DatePicker from opening
        >
            <StyledDialogTitle onClose={handleClosePopover} id="new">
                Filter Search
            </StyledDialogTitle>
            <Box sx={styles.filterPopoverContainer}>
                <Box sx={styles.filterRow}>
                    <Box sx={styles.filterFormLeftFields}>
                        <Typography variant="h6" gutterBottom fontSize={"15px"} pb={1}>
                            Employee Name
                        </Typography>
                        <Autocomplete
                            size="small"
                            fullWidth
                            options={dropDownOptions?.EmployeeName}
                            value={filterValues.dropdown1}
                            onChange={handleDropdownChange("dropdown1")}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        />
                    </Box>
                    <Box sx={styles.filterFormRightFields}>
                        <Typography variant="h6" gutterBottom fontSize={"15px"} pb={1} >
                            Role
                        </Typography>
                        <Autocomplete
                            size="small"
                            fullWidth
                            options={dropDownOptions?.Role}
                            value={filterValues.dropdown2}
                            onChange={handleDropdownChange("dropdown2")}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        />
                    </Box>
                </Box>
                <Box sx={styles.filterRow}>
                    <Box sx={styles.filterFormLeftFields}>
                        <Typography variant="h6" gutterBottom fontSize={"15px"} pb={1} >
                            Shift Type
                        </Typography>
                        <Autocomplete
                            size="small"
                            fullWidth
                            options={dropDownOptions?.ShiftType}
                            value={filterValues.dropdown3}
                            onChange={handleDropdownChange("dropdown3")}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        />
                    </Box>
                    <Box sx={styles.filterFormRightFields}>
                        {/* <Typography variant="h6" gutterBottom fontSize={"15px"} pb={1}>
                            Shift Status
                        </Typography>
                        <Autocomplete
                            size="small"
                            fullWidth
                            options={dropDownOptions?.ShiftStatus}
                            value={filterValues.dropdown4}
                            onChange={handleDropdownChange("dropdown4")}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        /> */}
                    </Box>
                </Box>
                <Box sx={styles.filterSubmitButton}>
                    <AppButton title="Filter" onClick={handleSubmit} />
                </Box>
            </Box>
        </Popover>
    );
};
